import { MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Copy } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { SkillProperties } from '../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { copySkillArea, getSkillAreas } from '../../../../../redux/State/clientSlice/skillAreaSlice';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

const CopySkill = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const isLoading = useSelector((state) => state.skillArea.loading);

	const [open, setOpen] = useState<boolean>(false);

	const onCopyClick = (event: MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
		setOpen(true);
	};

	const copySkillAreaHandler = () => {
		const { clientId, id } = item;

		if (!clientId || !id) return;

		dispatch(copySkillArea({ clientId, id }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getSkillAreas({ clientId, funderId: item.funderId }));
				setOpen(false);
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<div className="actionRow" onClick={onCopyClick}>
				<div className="actionIcon">
					<Copy />
				</div>
				<div className="actionContent">
					<Text title="Copy" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				isBusy={isLoading}
				open={open}
				onClose={() => setOpen(false)}
				title="Do you want to copy the selected skill area?"
				Content={() => (
					<ButtonWrapper isInModal>
						<CustomButton title="Yes" className="marginRight8" onClick={copySkillAreaHandler} />
						<CustomButton title="No" buttonType="secondaryGray" onClick={() => setOpen(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default CopySkill;
